import { render } from "./UsersInfo.vue?vue&type=template&id=88c7c89e"
import script from "./UsersInfo.vue?vue&type=script&lang=js"
export * from "./UsersInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__